/*
 * Copyright (C) 2024 Reseau Concept.
 * https://reseau-concept.com
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import { Action } from '@ngrx/store';

export const COLLABORA_EDIT = "COLLABORA_EDIT";

export class CollaboraOnlineEdit implements Action {
  readonly type = COLLABORA_EDIT;
  constructor(public payload: any) {}
}
